import LoginByPhone from './LoginByPhone';

export default LoginByPhone;
